import {
  DEFAULT_GOOGLE_MAP_ZOOM,
  DEFAULT_GOOGLE_MAP_LATITUDE, 
  DEFAULT_GOOGLE_MAP_LONGITUDE, 
} from '@src/core/controllers/map/config';
import { IMapControllerInitialState } from "./types";

const initialState: IMapControllerInitialState = {
  zoom: DEFAULT_GOOGLE_MAP_ZOOM,
  center: { lat: DEFAULT_GOOGLE_MAP_LATITUDE, lng: DEFAULT_GOOGLE_MAP_LONGITUDE },
  rulerActive: false,
  rulerPoints: [],
};

export default initialState;